/**
 * Update Store
 * Manages desktop app update state globally
 */

import { create } from 'zustand';

interface UpdateInfo {
  version: string;
  body: string;
}

interface UpdateState {
  // State
  updateAvailable: boolean;
  updateInfo: UpdateInfo | null;
  checking: boolean;
  installing: boolean;
  updateDownloaded: boolean;
  dismissed: boolean;
  downloadProgress: number;

  // Actions
  setUpdateAvailable: (available: boolean, info?: UpdateInfo | null) => void;
  setUpdateDownloaded: (downloaded: boolean) => void;
  setChecking: (checking: boolean) => void;
  setInstalling: (installing: boolean) => void;
  setDownloadProgress: (progress: number) => void;
  dismissUpdate: () => void;
  reset: () => void;
}

export const useUpdateStore = create<UpdateState>((set) => ({
  // Initial state
  updateAvailable: false,
  updateInfo: null,
  checking: false,
  installing: false,
  updateDownloaded: false,
  dismissed: false,
  downloadProgress: 0,

  // Actions
  setUpdateAvailable: (available, info = null) =>
    set({ updateAvailable: available, updateInfo: info, dismissed: false }),

  setUpdateDownloaded: (updateDownloaded) => set({ updateDownloaded }),

  setChecking: (checking) => set({ checking }),

  setInstalling: (installing) => set({ installing }),

  setDownloadProgress: (progress) => set({ downloadProgress: progress }),

  dismissUpdate: () => set({ dismissed: true }),

  reset: () =>
    set({
      updateAvailable: false,
      updateInfo: null,
      checking: false,
      installing: false,
      updateDownloaded: false,
      dismissed: false,
      downloadProgress: 0,
    }),
}));
